module.exports = __webpack_public_path__ + "assets/924da25f134755d6aa497edb3f631ba8.svg";